var map = {
	"./champ.png": "73e9",
	"./checkpoints.png": "d7d8",
	"./cover.png": "f5a3",
	"./cover2.png": "6024",
	"./logo.svg": "9b19",
	"./tailwind.css": "ba8c",
	"./tour.png": "4c5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";